import { useMemo } from "react";

// MUI
import { Link, Stack, Typography } from "@mui/material";

// Types
import { IProspectNote } from "@/DataPages/types/rci/salesLeads/model";

interface IRenderProspectNoteItemProps {
	item: IProspectNote;
}

const urlRegex = /(https?:\/\/[^\s]+)/g;
interface ContentSegment {
	text: string;
	isUrl: boolean;
}

const parseSegments = (text: string): ContentSegment[][] => {
	return text.split("\n").map((line) =>
		line.split(urlRegex).map((part) => ({
			text: part,
			isUrl: urlRegex.test(part),
		}))
	);
};

const RenderContentWithLinks = ({ text }: { text: string }) => {
	const commonClasses = "!font-sans !text-sm";
	const lines = useMemo(() => parseSegments(text), [text]);

	return (
		<>
			{lines.map((segments, lineIdx) => {
				const keyLineIndex = `line-${lineIdx}`;
				return (
					<Stack display="flex" direction="row" key={keyLineIndex}>
						{segments.map(({ text: part, isUrl }, idx) => {
							const keyIndex = `segment-${lineIdx}-${idx}`;
							return isUrl ? (
								<Link
									key={keyIndex}
									href={part}
									target="_blank"
									underline="hover"
									className={`!text-primary hover:!text-primary-hover ${commonClasses}`}
								>
									{part}
								</Link>
							) : (
								<Typography key={keyIndex} component="span" className={`!text-default ${commonClasses}`}>
									{part}
								</Typography>
							);
						})}
					</Stack>
				);
			})}
		</>
	);
};

const RenderProspectNoteItem = (props: IRenderProspectNoteItemProps) => {
	const { item } = props;
	const { header, content } = item;

	return (
		<Stack display={"flex"} direction="column" className="!w-full">
			{header && <Typography className="!font-sans !text-default !text-sm !font-semibold">{header}</Typography>}
			<RenderContentWithLinks text={content} />
		</Stack>
	);
};

export default RenderProspectNoteItem;
